<template>
    <AdminDashboardView v-if="isAdmin" />
    <PortalDashboardView v-else-if="isClient" />
    <div v-else class="tw-p-4">
        <div
            class="tw-min-h-[calc(100dvh-100px)] tw-w-full tw-bg-white tw-rounded tw-border tw-border-b-2 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-text-center tw-p-6">
            <icon icon="solar:home-smile-bold-duotone" class="tw-text-primary-500 tw-text-6xl" />
            <h1 class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ $t('pages.dashboard.welcome') }}</h1>
            <p class="tw-text-gray-500 tw-max-w-md">{{ $t('pages.dashboard.welcome-paragraph') }}</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';
import AdminDashboardView from '@/views/admin/DashboardView.vue';
import PortalDashboardView from '@/views/portal/PortalDashboardView.vue';

const authStore = useAuthStore();
const role = computed(() => authStore.user?.role);
const isAdmin = computed(() => ['admin', 'super_admin'].includes(role.value));
const isClient = computed(() => role.value === 'client');
</script>
